import cmp from './ThemeConfirmDialog'

export default cmp
